import { FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import { FaLinkedin, FaFacebookF, FaInstagram } from "react-icons/fa";
import '../../../styles/components/Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <h2 className="footer-title">About Us</h2>
          <p className="footer-description">
            At DEZINE, we bring creativity and innovation to every project. With over 6 years
            of experience, we specialize in graphic design, web development, and digital
            marketing. We've successfully completed 100+ projects for clients globally,
          </p>
          <p className="footer-description">
            helping businesses grow their brands with tailored solutions. Our goal is to
            deliver exceptional designs, strong online presence, and impactful branding to
            make your business stand out. Let’s work together to bring your vision to life!
          </p>
          <div className="footer-info">
            <p><FaMapMarkerAlt className="icon" /> 6800 Jericho Turnpike Suite 120w, Syosset New York 11791</p>
            <p><FaEnvelope className="icon" /> info@dezine95.com</p>
          </div>
          <div className="email-subscribe">
            <input type="email" placeholder="Email" className="email-input" />
            <button className="send-button">✈</button>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-logo">
           <img src="/images/logos/logo.png" alt="Logo" className="logo-image" />
        </div>
        <div className="social-icons">
          <FaLinkedin className="social-icon" />
          <FaFacebookF className="social-icon" />
          <FaInstagram className="social-icon" />
        </div>
      </div>
    </footer>
  );
}
